// extracted by mini-css-extract-plugin
export default {"video":"Video_video__fF2Y0"};